import { DatePicker, TimePicker } from '@trackman/web-shared-components';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const DateAndTimeSettings = ({startDate, setStartDate}: {startDate: string; setStartDate: (date: string) => void}) => {
  const getCombinedUTC = (newValue: Dayjs) => {
    if (!newValue.isValid()) {
      return '';
    }
    const combined = dayjs
      .utc()
      .year(newValue.year())
      .month(newValue.month())
      .date(newValue.date())
      .hour(newValue.hour())
      .minute(newValue.minute())
      .second(0)
      .millisecond(0);
    return combined.toISOString();
  };

  return (
    <div className='admin-edit-section'>
      <h2>Time*</h2>
      <div className='inputs-container time-settings'>
        <DatePicker
          inputFormat='DD/MM/YYYY'
          label='Date'
          value={startDate ? dayjs(startDate).utc() : dayjs()}
          onChange={(selectedDate) => (selectedDate ? setStartDate(getCombinedUTC(selectedDate)) : setStartDate(''))}
        />
        <TimePicker
          label='Time'
          minutesStep={5}
          value={startDate ? dayjs(startDate).utc() : null}
          onChange={(selectedTime) => (selectedTime ? setStartDate(getCombinedUTC(selectedTime)) : setStartDate(''))}
          hint='Please add time in UTC standard'
        />
      </div>
    </div>
  );
};
